"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeHueForKey = computeHueForKey;
/**
 * Deterministic avatar hue for a persona key.
 *
 * The hue is never stored and never sent over the wire: every renderer of
 * the colored-initial fallback avatar (`LetterFace` in
 * `client/component/people.tsx`, the embeddable teaser) derives it from the
 * persona key through this one function, so the same user gets the same
 * colour everywhere. The hash stays bit-for-bit identical to the original
 * client function it came from, so existing avatar colours don't shift.
 */
function computeHueForKey(key) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash) % 360;
}
//# sourceMappingURL=persona-hue.js.map